import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Placeholder from 'components/consumer/Placeholder';
const SellingAttributePlaceholder = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-row"><Placeholder type="rect" loading={true} className="shrink-0 !w-[42px] !h-[42px] !mr-0" /><Placeholder type="rect" loading={true} className="!w-full !h-[42px] !ml-[10px] !mr-0" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const PDPSellingAttributesPlaceholder = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Placeholder type="text" loading={true} row={1} className="!w-[115px] !h-6" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col border-t border-solid border-gray-light6 mt-14 pt-14 !w-full !h-60">{t0}<div className="flex flex-col space-y-1"><SellingAttributePlaceholder /><SellingAttributePlaceholder /><SellingAttributePlaceholder /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default PDPSellingAttributesPlaceholder;